import React from 'react'
import { Leaderboard } from '../../interfaces/leaderboard.interface'
import { AttachSuffixToRank } from '../../utilities/formatter'

const CardBoard = ({ score, rank }: Leaderboard & { rank: number }) => {
    return (
        <div className='p-4 rounded-lg bg-light-dark2 text-center w-full'>
            <h4 className='font-bold text-[24px] mb-1'><span className='text-[14px]'>{AttachSuffixToRank(rank)}</span></h4>
            <div className="px-4 py-2 rounded-lg" style={{ background: "rgba(255, 255, 255, 0.06)" }}>
                <p className='text-[12px]'>Score:</p>
                <h5 className='text-[14px] font-bold text-[#8DCA83]'>{score}</h5>
            </div>
        </div>
    )
}

export default CardBoard
